module.exports = __webpack_public_path__ + "static/media/logo_NPHCDA.100e4ffa.png";